
export default {
  name: 'MarketIndices',
}
